import React from 'react';
import DependentReview from './dependent-review';
import { Row, Column } from 'carbon-components-react';
import DependentsTable from './dependents-table';
import { useEffect } from 'react';
import { isObjectModified } from '../../components/property-mapper';
import { useState } from 'react';

const DependentsReview = ({modifiedArray, unmodifiedArray}) => {
    const [isModified, setIsModified] = useState();
    
    useEffect(() => {
        setIsModified(isObjectModified(modifiedArray, unmodifiedArray));
    }, []);
    
    return (  
        <>
        {modifiedArray || unmodifiedArray ?
            <div className='text-xl mb-2'>
            <span className={isModified ? 'text-purple' : 'text-danger'}>Dependents</span>
            <Row>
                <Column sm={{span: 0}} md={{span: 8}} className="p-0">
                    <DependentsTable modifiedArray={modifiedArray} unmodifiedArray={unmodifiedArray} />
                   <hr className='mt-4' />
                </Column>
                <Column md={{span:0}}>
                    {modifiedArray.map((modified) => {
                        const unmodified = unmodifiedArray?.find(s => s.id === modified.id);
                    return(
                            <div key={modified.id}>
                                <DependentReview modified={modified} unmodified={unmodified} />
                            </div>
                    );
                    }
                    )}
                    {
                        unmodifiedArray.filter(o=> !modifiedArray.some(i=> i.id === o.id)).map((removed) =>
                        <div key={removed.id} className="line-through text-sm border-solid border my-4 py-3 px-4">
                            {removed?.firstName} {removed?.lastName}
                        </div>
                    )}
                </Column>
            </Row>
            <hr />
        </div> : <></>
    }
        </>
    );
}
 
export default DependentsReview;